//字符函数--29个
export const StringFunc = [
  {
    "key": "StringSubstring",
    "name": "取子字符串"
  },
  {
    "key": "SubString",
    "name": "取子字符串",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "start",
        "name": "起始位置",
        "type": "int"
      },
      {
        "key": "length",
        "name": "长度",
        "type": "int"
      }
    ],
    "description": `【功能】：从字符串中指定位置开始，截取指定长度的字符串并返回\n【返回值类型】：字符串(String)\n【示例】：取子字符串("ABCDEFG",2,3)【返回值】："CDE"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringLength",
    "name": "取字符串长度"
  },
  {
    "key": "Length",
    "name": "取字符串长度",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：获取字符串的长度\n【返回值类型】：数值(Int32)\n【示例】：取字符串长度("ABCDEF")【返回值】：6`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "Contains",
    "name": "是否包含",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目标字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判断字符串中是否包含目标字符串\n【返回值类型】：布尔(Boolean)\n【示例】：是否包含(salesorder.code,"表达式")【返回值】：false`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NotContains",
    "name": "是否不包含",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目标字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判断字符串中是否不包含目标字符串\n【返回值类型】：布尔(Boolean)\n【示例】：是否不包含(salesorder.code,"表达式")【返回值】：true`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StartsWith",
    "name": "开头是",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目标字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判断字符串是否以目标字符串开头\n【返回值类型】：布尔(Boolean)\n【示例】：开头是(salesorder.code,"表达式")【返回值】：false`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NotStartsWith",
    "name": "开头不是",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目标字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判断字符串是否不以目标字符串开头\n【返回值类型】：布尔(Boolean)\n【示例】：开头不是(salesorder.code,"表达式")【返回值】：true`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "EndsWith",
    "name": "结尾是",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目标字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判断字符串是否以目标字符串结尾\n【返回值类型】：布尔(Boolean)\n【示例】：结尾是(salesorder.code,"表达式")【返回值】：false`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NotEndsWith",
    "name": "结尾不是",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目标字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判断字符串是否不以目标字符串结尾\n【返回值类型】：布尔(Boolean)\n【示例】：结尾不是(salesorder.code,"表达式")【返回值】：false`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringReplace",
    "name": "字符串替换"
  },
  {
    "key": "Replace",
    "name": "字符串替换",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "oldVal",
        "name": "被替换值",
        "type": "str"
      },
      {
        "key": "newVal",
        "name": "替换值",
        "type": "str"
      }
    ],
    "description": `【功能】：将字符串中的"被替换值"替换为"替换值"\n【返回值类型】：字符串(String)\n【示例】：字符串替换("123412","12","00")【返回值】："003400"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringToUpper",
    "name": "转大写"
  },
  {
    "key": "ToUpper",
    "name": "转大写",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：将字符串转换为大写\n【返回值类型】：字符串(String)\n【示例】：转大写("abc")【返回值】："ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringToLower",
    "name": "转小写"
  },
  {
    "key": "ToLower",
    "name": "转小写",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：将字符串转换为小写\n【返回值类型】：字符串(String)\n【示例】：转小写("ABC")【返回值】："abc"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringIndexOf",
    "name": "首个匹配字符索引"
  },
  {
    "key": "IndexOf",
    "name": "首个匹配字符索引",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目标字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：在字符串中检索目标字符串，找到首个匹配的字符串并返回索引位置(从0开始)。如果未找到则返回-1，如果目标字符串为空则返回0，如果原字符串为null则返回-1\n【返回值类型】：数值(Int32)\n【示例】：首个匹配字符索引("12001234012","01")【返回值】：3\n【示例】：首个匹配字符索引("12002323","34")【返回值】：-1\n【示例】：首个匹配字符索引("120011","")【返回值】：0`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringLastIndexOf",
    "name": "最后匹配字符索引"
  },
  {
    "key": "LastIndexOf",
    "name": "最后匹配字符索引",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目标字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：在字符串中检索目标字符串，找到最后一个匹配的字符串后返回索引位置(从0开始)。如果未找到则返回-1，如果目标字符串为空串则返回原字符串长度，如果原字符串为null则返回-1\n【返回值类型】：数值(Int32)\n【示例】：最后匹配字符索引("12001234012","01")【返回值】：8\n【示例】：最后匹配字符索引("12002323","34")【返回值】：-1\n【示例】：最后匹配字符索引("120011","")【返回值】：6`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringTrimStart",
    "name": "删除头部空格"
  },
  {
    "key": "TrimStart",
    "name": "删除头部空格",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：删除字符串的头部空格并返回\n【返回值类型】：字符串(String)\n【示例】：删除头部空格("    ABC")【返回值】："ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringTrimEnd",
    "name": "删除尾部空格"
  },
  {
    "key": "TrimEnd",
    "name": "删除尾部空格",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：删除字符串的尾部空格并返回\n【返回值类型】：字符串(String)\n【示例】：删除尾部空格("ABC    ")【返回值】："ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringTrim",
    "name": "删除头尾部空格"
  },
  {
    "key": "Trim",
    "name": "删除头尾部空格",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：删除字符串的头尾部空格并返回\n【返回值类型】：字符串(String)\n【示例】：删除头尾部空格("    ABC    ")【返回值】："ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "CreateGuid",
    "name": "唯一标识符",
    "params": [],
    "description": `【功能】：获取唯一标识符Guid\n【返回值类型】：字符串(String)\n【示例】：唯一标识符()【返回值】："7722A793-14DF-49CD-B7E7-DF4987YYD2"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringAdd",
    "name": "字符串相加"
  },
  {
    "key": "Add",
    "name": "字符串相加",
    "params": [
      {
        "key": "str1",
        "name": "第一个字符串",
        "type": "str"
      },
      {
        "key": "str2",
        "name": "第二个字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：将若干字符串拼接成一个新字符串，最多支持10个字符串拼接，最少2个；编辑器中默认插入两个，多个字符串可手动添加\n【返回值类型】：字符串(String)\n【示例】：字符串相加("Hello","World")【返回值】："HelloWord"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  }
]